import styled from "styled-components";

export const AppBarWrapper = styled.div`
  width: 100%;
  top: 56px;
  flex-grow: 1;
  position: fixed;
  z-index: 1000;
  background: #fff;
  @media (max-width: 1280px) {
    header {
      padding-bottom: 12px;
    }
  }

  @media (max-width: 768px) {
    top: 0;
  }
`;

interface MenuListWrapperProps {
  direction?: "row" | "column";
}

export const MenuListWrapper = styled.ul<MenuListWrapperProps>`
  display: flex;
  margin: 0;
  padding: 0;
  justify-content: center;
  flex-direction: ${(props) => props.direction || "row"};

  @media (max-width: 1024px) {
    display: none;
  }
`;

interface IMenuListOption {
  active?: boolean;
}

export const MenuListOption = styled.button<IMenuListOption>`
  position: relative;
  display: flex;
  height: 100%;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  cursor: pointer;
  background: transparent;
  border: none;
  text-transform: uppercase;
  font-weight: 500;
  color: ${(props) => (props.active ? "#2786BD" : "#0a5079")};
  font-size: 14px;

  &:hover {
    background-color: #eef8ff;
  }
`;

export const LogoImage = styled.img`
  height: 90px;
  margin: 8px 0px;

  @media (max-width: 1440px) {
    height: 80px;
  }

  @media (max-width: 1024px) {
    height: 60px;
  }
`;

export const SubMenuList = styled.ul`
  position: absolute;
  background: #fff;
  border-radius: 2px;
  padding: 12px;
  width: 200px;
  top: 56px;
  z-index: 1000;
`;

export const SubMenuItem = styled.li`
  position: relative;
  display: flex;
  align-items: center;
  color: #2786bd;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  padding: 12px 8px;
  border-bottom: 1px solid #e9e9e9;
  white-space: nowrap;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #eef8ff;
    cursor: pointer;
    transition: 0.2s linear;
  }
`;

export const SearchButton = styled.button`
  width: 56px;
  height: 56px;
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2786bd;
  transition: all 0.2s linear;
  border: none;
  cursor: pointer;

  &:hover {
    background: #0a5079;
  }
`;

export const CustomGrid = styled.div`
  @media (max-width: 1024px) {
    display: none;
  }
`;
export const MenuButton = styled.button`
  border: none;
  background: transparent;
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MenuButonGridItem = styled.div`
  display: none;

  @media (max-width: 1024px) {
    display: block;
  }
`;

export const EntityInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 12px;
  gap: 2px;

  @media (max-width: 1280px) {
    display: none;
  }
`;

export const EntityTypeText = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #666;
  line-height: 1.3;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const EntityCityName = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: #0a5079;
  line-height: 1.3;
  text-transform: uppercase;

  @media (max-width: 1440px) {
    font-size: 20px;
  }
`;

export const LogoEntityWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

export const MegaMenuContainer = styled.div`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;

  @media (max-width: 1024px) {
    display: none;
  }
`;
